import { getQueryStringParameters } from 'owa-querystring';
import { getOrigin } from 'owa-url';
import { setIsDeepLinkAction } from 'owa-calendar-actions/lib/actions/routingActions';
import { lazyOpenAddCalendarsPane, lazySetAndNavigateWebImport } from 'owa-calendar-addcalendar';

/**
 * Route handle for browse discover calendars dialog
 */
export default async function browseDiscoverCalendarsRouteHandler() {
    setIsDeepLinkAction(true);

    if (location.search) {
        // Check only for search params
        const { url, name } = getQueryStringParameters();

        if (url) {
            lazySetAndNavigateWebImport.importAndExecute(url, name);
            lazyOpenAddCalendarsPane.importAndExecute('DeepLink');

            const newUrl = `${getOrigin()}${location.pathname}`;
            window.history.replaceState(null, null, newUrl);
        }
    }

    lazyOpenAddCalendarsPane.importAndExecute('DeepLink');
}
